import React from 'react';
import Script from 'next/script';
import { useDisabledFeatureFlags } from 'lib/hooks/useDisabledFeatureFlags';

export interface AdChoicesScriptProps {
  strategy?: 'beforeInteractive' | 'afterInteractive' | 'lazyOnload' | 'worker';
}

export function AdChoicesScript({ strategy = 'lazyOnload' }: AdChoicesScriptProps) {
  // Early return if ADCHOICES is disabled from feature flags in site settings
  const disabledFeatures = useDisabledFeatureFlags();
  if (disabledFeatures?.ADCHOICES) {
    return <></>;
  }

  return (
    <Script
      id="adchoices-truste-script"
      src="https://preferences.trustarc.com/webservices/js?domain=generalmillscore.com&type=pop2&js=responsive"
      type="text/javascript"
      strategy={strategy}
      onError={(e) => {
        console.warn('AdChoicesScript: Failed to load script', e);
      }}
    />
  );
}
